<template>
  <v-dialog v-model="isShareDialog" class="share-dialog" width="380px" @click:outside="close" @keydown.esc="close">
    <v-row no-gutters style="background-color: #21343b; justify-content: space-between" class="px-3 py-5">
      <span class="txt-section-title ml-2 mt-2 mb-4">{{ $t('shareMeetingTitle') }}</span>
      <v-btn dark elevation="0" icon @click="close">
        <v-icon color="white">mdi-close</v-icon>
      </v-btn>
      <v-tabs v-model="tab" dark background-color="transparent" grow height="40">
        <v-tab v-for="item in items" :key="item">
          {{ item }}
        </v-tab>
      </v-tabs>
    </v-row>
    <v-tabs-items v-model="tab" style="background-color: #21343b">
      <v-tab-item key="share">
        <v-row justify="space-between" style="background-color: #21343b; margin: 0 !important" class="px-2">
          <v-col class="container-copy-url" cols="12" align="center">
            <v-btn class="btn-copy-url" color="rgb(40, 144, 103)" width="100%" @click="copyUrlToClipboard">
              <span class="material-icons-round mr-2" translate="no" style="font-size: 20px; font-weight: 400">
                link
              </span>
              {{ isMobile ? 'Share' : 'Copy' }} Link
            </v-btn>
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item key="embed">
        <v-radio-group v-model="radioEmbed" class="ml-5 my-1" hide-details>
          <v-radio dark value="responsive" class="mb-5">
            <template v-slot:label>
              <div style="font-size: 14px !important">Responsive size</div>
            </template>
          </v-radio>
          <v-radio dark value="fixed" class="mb-3">
            <template v-slot:label>
              <div style="font-size: 14px !important">Fixed size</div>
            </template>
          </v-radio>
        </v-radio-group>
        <v-expand-transition>
          <v-row
            justify="center"
            align="center"
            style="color: #aaa"
            class="container-fixed-embed my-2"
            v-if="radioEmbed == 'fixed'"
          >
            <v-col cols="4">
              <v-text-field
                solo
                v-model="embedWidth"
                hide-details
                rounded
                dense
                @keyup="calculateFixedHeight"
              ></v-text-field>
            </v-col>
            x
            <v-col cols="4">
              <v-text-field
                solo
                v-model="embedHeight"
                hide-details
                rounded
                dense
                @keyup="calculateFixedWidth"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-expand-transition>
        <v-row justify="space-between" style="background-color: #21343b; margin: 0 !important" class="px-2">
          <v-col class="container-copy-url" cols="12" align="center">
            <v-btn class="btn-copy-url" color="rgb(40, 144, 103)" width="100%" @click="copyIframeCodeToClipboard">
              <span class="material-icons-round mr-2" translate="no" style="font-size: 20px">code</span>
              {{ 'Copy embed code' }}
            </v-btn>
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>
    <v-row
      justify="space-between"
      v-if="isMtOrganizer || isWsManager || isWsOwner"
      style="background-color: #21343b; margin: 0 !important; font-size: 14px"
      class="px-2"
    >
      <v-col align-self="center">
        <span style="color: #96a7af">Anyone with the link can view / post</span>
      </v-col>
      <v-col cols="auto">
        <el-switch
          v-model="currentMt.isPublic"
          @change="setPublicMt"
          active-color="rgb(40, 144, 103)"
          inactive-color="#d4f3e8"
        ></el-switch>
      </v-col>
    </v-row>
    <v-row
      justify="space-between"
      v-if="currentClip && currentClip !== null && currentClip.length !== 0"
      style="background-color: #21343b; margin: 0 !important; font-size: 14px"
      class="px-2 pb-3"
    >
      <v-col align-self="center" cols="auto">
        <span style="color: #96a7af">Start from current clip</span>
      </v-col>
      <v-col cols="auto">
        <el-switch v-model="clipValue" active-color="rgb(40, 144, 103)" inactive-color="#d4f3e8"></el-switch>
      </v-col>
    </v-row>
  </v-dialog>
</template>

<script>
import { copy } from '@/common/common'
import { isMobile, isSafari } from '@/common/lib/strLib'
import { getShareUrl, setUserFunnel } from '@/services/api'
import { setPublicMt } from '@/services/meetingApi'
import { mapGetters } from 'vuex'
import Toast from '@/views/meeting/component/Toast'

export default {
  name: 'ShareDialog',
  props: { isShareDialog: Boolean },
  data() {
    return {
      path: '',
      clipValue: false,
      safariPath: null,
      safariPathWithClipId: null,
      tab: null,
      items: ['Share', 'Embed'],
      radioEmbed: 'responsive',
      embedWidth: '640',
      embedHeight: '480',
    }
  },
  created() {
    if (this.isSafari) this.setSafariUrl()
  },
  mounted() {
    document.addEventListener('keydown', this.keyEvent)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.keyEvent)
  },
  methods: {
    keyEvent(e) {
      // S 누르면 다이얼로그 닫기
      if (
        !(e.target instanceof HTMLTextAreaElement) &&
        !(e.target instanceof HTMLInputElement) &&
        e.target.contentEditable !== 'true'
      ) {
        if (!e.ctrlKey && !e.metaKey && e.keyCode == 83) {
          this.$emit('close', 'Share')
          e.preventDefault()
        }
      }
    },
    async setSafariUrl() {
      // TODO: 중복 코드 정리 필요할 듯 합니다
      let title = this.currentMt.mtTopic
      let imgUrl = this.currentMt.mtThumbsUrl
      let routePayload = {
        name: 'ChannelMeetingShare',
        params: {
          wsDomain: this.$route.params['wsDomain'],
          chId: this.selectedCh && this.selectedCh['chId'] ? this.selectedCh['chId'].replace('CH:', '') : '',
          mtId: this.$route.params['mtId'],
        },
      }
      let linkUrl = location.origin + this.$router.resolve(routePayload).href
      let content = ''

      let copyUrl = await getShareUrl(this, title, content, imgUrl, linkUrl)

      this.safariPath = copyUrl.shortLink

      content = this.currentClip.clipNote
      if (this.currentClip.clipThumbsUrl) imgUrl = this.currentClip.clipThumbsUrl
      linkUrl += '?clipId=' + this.currentClip.clipId

      copyUrl = await getShareUrl(this, title, content, imgUrl, linkUrl)
      this.safariPathWithClipId = copyUrl.shortLink
    },
    async copyUrlToClipboard() {
      let copyResult
      let safariUrl = this.clipValue ? this.safariPathWithClipId : this.safariPath
      if (this.isSafari && this.safariUrl !== null) {
        copyResult = await copy(safariUrl)
      } else {
        await this.createShareUrl()
        copyResult = await copy(this.path)
      }

      if (copyResult) {
        this.checkFunnel()
        this.$store.dispatch('setFirebaseLog', {
          eventName: 'share',
          eventParam: {
            name: 'share',
            methodType: this.clipValue ? 'clip' : 'meeting',
          },
        })
        if (!this.isMobile) {
          // notify(this, 'Success', this.$t('copiedClipboardUrl'), 'success')
          const content = {
            component: Toast,
            props: {
              msg: this.$t('copiedClipboardUrl'),
              // submsg: '',
            },
          }
          this.$toast.success(content)
        }
      } else {
        // notify(this, 'Error', this.$t('failedCopy'), 'error')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('failedCopy'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
      }
    },
    async copyIframeCodeToClipboard() {
      let copyResult
      let safariUrl = this.clipValue ? this.safariPathWithClipId : this.safariPath
      if (this.isSafari && this.safariUrl !== null) {
        copyResult = await copy(safariUrl + '?embed=basic')
      } else {
        await this.createIframeUrl()
        copyResult = await copy(this.path)
      }

      if (copyResult) {
        this.checkFunnel()
        this.$store.dispatch('setFirebaseLog', {
          eventName: 'share',
          eventParam: {
            name: 'share',
            methodType: 'clip',
          },
        })
        if (!this.isMobile) {
          // notify(this, 'Success', this.$t('copiedClipboardUrl'), 'success')
          const content = {
            component: Toast,
            props: {
              msg: this.$t('copiedClipboardUrl'),
              // submsg: '',
            },
          }
          this.$toast.success(content)
        }
      } else {
        // notify(this, 'Error', this.$t('failedCopy'), 'error')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('failedCopy'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
      }
    },
    async checkFunnel() {
      if (this.userInfo !== null) {
        try {
          const funnel = this.userInfo.funnel
          if (!funnel || funnel === '' || funnel === 'evaluator') {
            let result = await setUserFunnel(this, 'beginner')
            this.$store.commit('setUserInfo', result)

            this.$store.dispatch('setFirebaseLog', {
              eventName: 'funnel_beginner',
              eventParam: {
                createdAt: Date.now(),
                methodType: 'share_meeting',
              },
            })
          }
        } catch (e) {
          console.log()
        }
      }
    },
    async createShareUrl() {
      // TODO: 중복 코드 정리 필요할 듯 합니다
      let title = this.currentMt.mtTopic
      let imgUrl = this.currentMt.mtThumbsUrl
      let routePayload = {
        name: 'ChannelMeetingShare',
        params: {
          wsDomain: this.$route.params['wsDomain'],
          chId: this.selectedCh && this.selectedCh['chId'] ? this.selectedCh['chId'].replace('CH:', '') : '',
          mtId: this.$route.params['mtId'],
        },
      }
      let linkUrl = location.origin + this.$router.resolve(routePayload).href
      let content = ''
      if (this.clipValue) {
        content = this.currentClip.clipNote
        if (this.currentClip.clipThumbsUrl) imgUrl = this.currentClip.clipThumbsUrl
        linkUrl += '?clipId=' + this.currentClip.clipId
      }

      // 공유 URL 생성 // TODO: fallbackUrl은 나중에 추가
      let copyUrl = await getShareUrl(this, title, content, imgUrl, linkUrl)
      this.path = copyUrl.shortLink
    },
    async createIframeUrl() {
      let routePayload = {
        name: 'ChannelMeetingShare',
        params: {
          wsDomain: this.$route.params['wsDomain'],
          chId: this.selectedCh && this.selectedCh['chId'] ? this.selectedCh['chId'].replace('CH:', '') : '',
          mtId: this.$route.params['mtId'],
        },
      }

      let linkUrl

      if (this.radioEmbed == 'fixed') {
        linkUrl = '<iframe width="' + this.embedWidth + '" height="' + this.embedHeight + '" src="'
      } else {
        linkUrl = '<div style="position: relative; padding-bottom: 56.25%; height: 0;"><iframe src="'
      }

      linkUrl += location.origin + this.$router.resolve(routePayload).href
      if (this.clipValue) {
        linkUrl += '?clipId=' + this.currentClip.clipId
      }

      if (this.radioEmbed == 'fixed') {
        linkUrl += '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>'
      } else {
        linkUrl +=
          '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe></div>'
      }

      this.path = linkUrl
    },
    async setPublicMt() {
      try {
        await this.$store.dispatch('setIsLoading', true)
        await setPublicMt(this, this.selectedWsInfo.wsId, this.currentMt.mtId, '*', this.currentMt.isPublic)
      } catch (error) {
        console.log(error)
      } finally {
        await this.$store.dispatch('setIsLoading', false)
      }
    },
    close() {
      this.$emit('close', 'Share')
    },
    calculateFixedHeight() {
      this.embedHeight = Math.round((this.embedWidth / 4) * 3)
    },
    calculateFixedWidth() {
      this.embedWidth = Math.round((this.embedHeight / 3) * 4)
    },
  },
  computed: {
    ...mapGetters([
      'selectedWsInfo',
      'selectedCh',
      'currentMt',
      'currentClip',
      'userInfo',
      'isMtOrganizer',
      'isWsManager',
      'isWsOwner',
    ]),
    isMobile() {
      return isMobile()
    },
    isSafari() {
      return isSafari()
    },
  },
}
</script>

<style scoped>
.share-dialog {
  background-color: #21343b;
}
.txt-section-title {
  font-weight: 700;
  font-size: 18px;
  color: white;
  align-self: center;
}
.v-dialog__content >>> .v-dialog {
  border-radius: 24px;
  overflow: hidden;
}
.container-copy-url >>> .v-btn * {
  font-size: 14px;
  color: white;
  letter-spacing: 0;
  text-transform: none;
  font-weight: bold;
}
.v-tab {
  text-transform: none;
  letter-spacing: 0.5px;
}
.container-fixed-embed >>> .v-text-field__slot input {
  font-size: 13px;
  text-align: center !important;
}
</style>
